import RouterLink from "../../Link/RouterLink";
import "./TrainingPrices.css";

interface TrainingPricesProps {
  rates: Array<any>;
  type: string;
}

function TrainingPrices(props: TrainingPricesProps) {
  return (
    <section className={`training-prices training-${props?.type}`}>
      <h2 className="training-prices-title">les tarifs</h2>
      <div
        className="sp-scroller-container sp-scroller-lock"
        id="prices-scroller"
      >
        {props?.rates?.map((rate, idx) => {
          return (
            <div
              className="sp-scroller-panel training-panel"
              key={"rate-" + idx}
            >
              <div className="training-panel-price">
                {rate?.price === 0 && (
                  <>
                    <span className="training-price-start">A partir d'un</span>
                    <div className="training-price-amount">
                      <span className="training-price-bold">Devis</span>
                      <span className="training-price-symbol"></span>
                    </div>
                    <span className="training-price-end training-price-quote"></span>
                  </>
                )}
                {rate?.price > 0 && (
                  <>
                    <span className="training-price-start">A partir de</span>
                    <div className="training-price-amount">
                      <span className="training-price-bold">{rate?.price}</span>
                      <span className="training-price-symbol">€</span>
                    </div>
                    {rate?.unit && (
                      <span className="training-price-end">
                        par {rate.unit}
                      </span>
                    )}
                    {!rate?.unit && (
                      <span className="training-price-end training-price-quote"></span>
                    )}
                  </>
                )}
              </div>
              <h4 className="training-panel-title">{rate?.title}</h4>
              <p className="training-panel-description">{rate?.description}</p>
            </div>
          );
        })}
      </div>
      <div className="sp-scroller-dots sp-scroller-dots-hide">
        {props?.rates?.map((_, idx) => {
          return (
            <div className="sp-scroller-dot" key={"rate-dot-" + idx}></div>
          );
        })}
      </div>
      <RouterLink to="/contact" className="sp-button">
        <span className="sp-button-text">Nous contacter</span>
        <div className="sp-button-arrow"></div>
      </RouterLink>
    </section>
  );
}

export default TrainingPrices;
